<template>
  <div class='submenu'>
    <ul>
      <li><a href="" class='active'>超声波流量计</a></li>
      <li><a href="">超声波燃气表</a></li>
      <li><a href="">普通燃气表</a></li>
      <li><a href="">水表</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SubMenu2',
  components: {

  },

  props: {
    // msg: String
  }
}
</script>

<style>
.submenu {
  display: block;
  background-color: rgba(0, 0, 0, .7);
}

.submenu ul {
  /*margin: 1.875vw auto;*/
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  padding-bottom: 10px;
}

.submenu ul li {
  flex-grow: 1;
  display: inline;
  /* 让列表项水平显示 */
  margin-right: 1.875vw;
  /* 添加一些右边距，使菜单项之间有间隔 */
  position: relative;
  /* 设置定位，以便横线位于文字下方 */
}

.submenu ul li a {
  /*padding: 1.875vw 3.75vw;*/
}

.submenu ul li a.active:after {
  content: ''; /* 使用伪元素添加横线 */
  position: absolute; /* 设置绝对定位 */
  left: 45%; /* 横线的左边与文字对齐 */
  bottom: 0; /* 横线的底部与文字对齐 */
  width: 10%; /* 横线的宽度 */
  height: 1px; /* 横线的高度 */
  background: #fff; /* 横线的颜色 */
  transition: background-color 0.3s; /* 可选：为横线添加过渡效果 */
}

.submenu ul li a:hover {
  background-color: #448CD3;
}

  /* 在这里添加针对手机屏幕的样式 */
  .submenu {
    /*visibility: hidden;*/
    display: none;
  }

@media (min-width: 768px) {
  .submenu {
    display: block;

  }
  .submenu ul {
    width: 700px;
    margin:0 auto;

}
  .submenu ul li a {
    padding: 5px 20px;
  }
}
@media (min-width: 960px) {

  .submenu ul {
    width: 900px;
  }
}
@media (min-width:1200px) {

  .submenu ul {
    width: 1200px;
  }}
</style>